import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./Naphtha.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}


function Naphtha() {

    useEffect(() => {
    
      trackPageVisit("Naphtha");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
  const {processData,  setProcessData} = useContext(ProcessContext);

     

  const DEFAULT_VALVES = {
  FCV_3501: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3502: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3503: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3504: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("Naphtha_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_3501: { ...DEFAULT_VALVES.FCV_3501, ...parsed.FCV_3501 },
      FCV_3502: { ...DEFAULT_VALVES.FCV_3502, ...parsed.FCV_3502 },
      FCV_3503: { ...DEFAULT_VALVES.FCV_3503, ...parsed.FCV_3503 },
      FCV_3504: { ...DEFAULT_VALVES.FCV_3504, ...parsed.FCV_3504 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("Naphtha_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================
    
                const { transmitters,  } = usePlantStore();
                const TT_28023 = transmitters.TT_28023 || 0;
                const PT_28023 = transmitters.PT_28023 || 0;
                const FIC_28023 = transmitters.FIC_28023 || 0;
  




  const xv3501Open = !valves?.XV_3501;
  const xv3502Open = !valves?.XV_3502;
  const xv3503Open = !valves?.XV_3503;
  const xv3504Open = !valves?.XV_3504;
  const xv3505Open = !valves?.XV_3505;
  const xv3506Open = !valves?.XV_3506;


    const FIC_3501 = FIC_28023;
    const PT_3501 = PT_28023;


    
/* =========================================================
              SPLITTING MAIN NAPHTHA LINE
========================================================= */

const openNaphthaTankSplit =
[
  xv3501Open,
  xv3502Open
].filter(Boolean).length;

const FIC_3502 =
  xv3501Open
    ? FIC_3501 / openNaphthaTankSplit
    : 0;

const FIC_3503 =
  xv3502Open
    ? FIC_3501 / openNaphthaTankSplit
    : 0;






/* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};
const togglePump = pumpContext.togglePump || (() => {});

/* =========================================================
   P-3501A / P-3501B STATUS
========================================================= */

const P3501A_Running =
pumpData?.["P-3501A"]?.running ?? false;

const P3501B_Running =
pumpData?.["P-3501B"]?.running ?? false;

const P3501_Running =
P3501A_Running || P3501B_Running;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P3501_CAPACITY = 12.5;


/* =========================================================
   CONTROL VALVE
========================================================= */

const FCV3501_Opening =
(valveData?.FCV_3501?.opening || 0) / 100;


/* =========================================================
   TARGET FLOW
========================================================= */

const targetFIC3504 =
(
P3501_Running
)
?
P3501_CAPACITY *
FCV3501_Opening
:
0;


/* =========================================================
   FLOW UPDATE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const current =
Number(prev.FIC_3504 || 0);

const next =
current +
(targetFIC3504-current)*0.12;

return{

...prev,

FIC_3504:
Number(next.toFixed(3))

};

});

},500);

return()=>clearInterval(timer);

},
[
targetFIC3504
]);



/* =========================================================
   PRESSURE + TEMPERATURE ENGINE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const currentPressure =
Number(prev.PT_3504 || 0.03);

const currentTemp =
Number(prev.TT_3504 || 28);

const currentFlow =
Number(prev.FIC_3504 || 0);

let targetPressure = 0.03;
let targetTemp = 28;


/* =========================================
   PUMP RUNNING
========================================= */

if(P3501_Running){

/* -----------------------------------------
   PRESSURE
----------------------------------------- */

// Dead-head (Valve fully closed)

if(FCV3501_Opening<=0){

targetPressure=1.80;

}

// Highly restricted

else if(FCV3501_Opening<0.20){

const restriction =
(0.20-FCV3501_Opening)/0.20;

targetPressure=
0.80+
restriction*
1.00;

}

// Normal operation

else{

targetPressure=
0.80-
(
FCV3501_Opening-
0.20
)*0.18;

}


/* -----------------------------------------
   TEMPERATURE
----------------------------------------- */

targetTemp=28;

// Dead-head heating

if(FCV3501_Opening<=0){

targetTemp=36;

}

// Restricted flow heating

else if(FCV3501_Opening<0.20){

const restriction=
(0.20-FCV3501_Opening)/0.20;

targetTemp=
28+
restriction*4;

}

}


/* =========================================
   UPDATE
========================================= */

return{

...prev,

PT_3504:
Number(
(
currentPressure+
(
targetPressure-currentPressure
)*0.08
).toFixed(3)
),

TT_3504:
Number(
(
currentTemp+
(
targetTemp-currentTemp
)*0.08
).toFixed(2)
)

};

});

},500);

return()=>clearInterval(timer);

},
[
P3501_Running,
FCV3501_Opening
]);


/* =========================================================
   TRANSMITTERS
========================================================= */

const FIC_3504 =
Number(
processData.FIC_3504 || 0
);

const PT_3504 =
Number(
processData.PT_3504 || 0.03
);

const TT_3504 =
Number(
processData.TT_3504 || 28
);





/* =========================================================
   V-3501 SUCTION FLOW
========================================================= */
const FIC_3505 = (P3501A_Running && xv3503Open) ? FIC_3504 : 0.003;

/* =========================================================
   V-3502 SUCTION FLOW
========================================================= */
const FIC_3506 = (P3501A_Running && xv3504Open) ? FIC_3504 : 0.003;











    
/* =========================================================
              SPLITTING MAIN Naphtha LINE
========================================================= */



const openNaphthaLineSplit =
[
  xv3505Open,
  xv3506Open
].filter(Boolean).length;

const FIC_3507 =
  xv3505Open
    ? FIC_3504 / openNaphthaLineSplit
    : 0;

const FIC_3508 =
  xv3506Open
    ? FIC_3504 / openNaphthaLineSplit
    : 0;





useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_3507 === FIC_3507 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_3507,
    }
  });

}, [FIC_3507, ]);













  return (
    <div className="Naphtha-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 353px",
          zIndex: 10,
        }}
      >
        NAPHTHA TANKS
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-3501 */}
      <Valve
        className="XV-3501"
        tag="XV_3501"
        x={314}
        y={355}
        isClosed={valves.XV_3501}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-3502 */}
      <Valve
        className="XV-3502"
        tag="XV_3502"
        x={774}
        y={355}
        isClosed={valves.XV_3502}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3503 */}
      <Valve
        className="XV-3503"
        tag="XV_3503"
        x={534}
        y={365}
        isClosed={valves.XV_3503}
        toggle={toggleValve}
      />

      {/* XV-3504 */}
      <Valve
        className="XV-3504"
        tag="XV_3504"
        x={1083}
        y={355}
        isClosed={valves.XV_3504}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3505 */}
      <Valve
        className="XV-3505"
        tag="XV_3505"
        x={1033}
        y={561}
        isClosed={valves.XV_3505}
        toggle={toggleValve}
      />

      {/* XV-3506 */}
      <Valve
        className="XV-3506"
        tag="XV_3506"
        x={1033}
        y={671}
        isClosed={valves.XV_3506}
        toggle={toggleValve}
      />




      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-3501 */}
        <div
            style={{ position: "absolute", left: 865, top: 553}}
            onMouseEnter={() => setHoveredValve("FCV_3501")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_3501")}
          >

            {hoveredValve === "FCV_3501" && (
              <div style={tagStyle}>
                FCV_3501
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-3501">
                    
          <defs>
            <linearGradient id="metal_3501">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_3501)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_3501)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
     
      
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 350 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40, 
                y: 350 + index * 40
              }}
            />
          ))}





      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_3501?.opening || 0)}
        x={887}
        y={600}
        description="NAPHTHA PRODUCT FLOW CONTROL VALVE OPENING"
        marginRight={5}
        marginBottom={6}
      />




    <Transmitter
        tag="FIC_3501"
        value={[FIC_3501]}
        x={121}
        y={325}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF FROM STABILIZER TOWER THROUGH E-304A/B TO NAPHTHA STORAGE TANKS)"
      />

    <Transmitter
        tag="PT_3501"
        value={[PT_3501]}
        x={181}
        y={455}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF FROM STABILIZER TOWER THROUGH E-304A/B TO NAPHTHA STORAGE TANKS)"
      />

      <Transmitter
        tag="FIC_3502"
        value={[FIC_3502]}
        x={281}
        y={255}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NAPHTHA FROM STABILIZER TOWER THROUGH E-304A/B TO NAPHTHA STORAGE TANKS)"
      />

      <Transmitter
        tag="FIC_3503"
        value={[FIC_3503]}
        x={741}
        y={255}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NAPHTHA FROM E-117A/B TO NAPHTHA STORAGE TANKS (V-303 AND V-304)"
      />

      <Transmitter
        tag="FIC_3504"
        value={[FIC_3504]}
        x={783}
        y={593}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NAPHTHA FROM P-3501A/B TO LOADING OR BLENDING"
      />


      <Transmitter
        tag="PT_3504"
        value={[PT_3504]}
        x={683}
        y={593}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF NAPHTHA FROM P-3501A/B TO LOADING OR BLENDING"
      />
    
    <Transmitter
        tag="TT_3504"
        value={[TT_3504]}
        x={683}
        y={503}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF NAPHTHA FROM P-3501A/B TO LOADING OR BLENDING"
      />

      <Transmitter
        tag="FIC_3507"
        value={[FIC_3507]}
        x={1113}
        y={553}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NAPHTHA FROM P-3501A/B TO LOADING GANTRY"
      />

      <Transmitter
        tag="FIC_3508"
        value={[FIC_3508]}
        x={1113}
        y={663}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NAPHTHA FROM P-3501A/B TO FUEL OIL BLENDING TANK"
      />






      <LevelTransmitterIndicator
      tag="LT_3501"
      totalLevel={95000}
      inflows={[FIC_3502]}
      outflows={[FIC_3505]}
      responseFactor={0.05}
      columnX={563}
      columnY={139}
      columnWidth={30}
      columnHeight={179}
      textX={610}
      textY={150}
      showFlow={true}
      service="Naphtha"
    />

    <LevelTransmitterIndicator
      tag="LT_3501"
      totalLevel={95000}
      inflows={[FIC_3502]}
      outflows={[FIC_3505]}
      responseFactor={0.05}
      columnX={396}
      columnY={139}
      columnWidth={199}
      columnHeight={181}
      textX={610}
      textY={150}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="Naphtha"
    />


      <LevelTransmitterIndicator
      tag="LT_3502"
      totalLevel={95000}
      inflows={[FIC_3503]}
      outflows={[FIC_3506]}
      responseFactor={0.05}
      columnX={1009}
      columnY={139}
      columnWidth={30}
      columnHeight={179}
      textX={1050}
      textY={150}
      showFlow={true}
      service="Naphtha"
    />

    <LevelTransmitterIndicator
      tag="LT_3502"
      totalLevel={95000}
      inflows={[FIC_3503]}
      outflows={[FIC_3506]}
      responseFactor={0.05}
      columnX={841}
      columnY={139}
      columnWidth={199}
      columnHeight={181}
      textX={1050}
      textY={150}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="Naphtha"
    />



            <Pump
              tag="P-3501A"
              x={568}
              y={520}
              rpm={1800}
              bladeCount={pumpData?.["P-3501A"]?.bladeCount || 3}
              size={pumpData?.["P-3501A"]?.size || 45}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-3501B"
              x={568}
              y={614}
              rpm={1800}
              bladeCount={pumpData?.["P-3501B"]?.bladeCount || 3}
              size={pumpData?.["P-3501B"]?.size || 45}
              onClick={openPumpPanel}
            />






    </div>
  );
}

export default Naphtha;